import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function SectionAnchorHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const attachAnchors = () => {
      const headings = document.querySelectorAll("#posts h2.post-sect, #posts h2, #posts h3");
      headings.forEach((heading) => {
        if (heading.querySelector(".heading-anchor")) return;

        if (!heading.id) {
          const rawText = heading.textContent || "";
          const slug = rawText
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
          if (slug) {
            heading.id = slug;
          }
        }

        if (!heading.id) return;

        const anchor = document.createElement("a");
        anchor.className = "heading-anchor";
        anchor.href = `#${heading.id}`;
        anchor.setAttribute("aria-label", `Link to ${heading.textContent}`);
        anchor.title = "Direct link to section";
        anchor.textContent = "#";

        anchor.addEventListener("click", async () => {
          const url = `${window.location.origin}${window.location.pathname}#${heading.id}`;
          try {
            await navigator.clipboard.writeText(url);
            anchor.setAttribute("data-copied", "true");
            setTimeout(() => {
              anchor.removeAttribute("data-copied");
            }, 1800);
          } catch {
            /* ignore */
          }
        });

        heading.appendChild(anchor);
      });

      // If a URL hash is present, smoothly scroll to it once headings are configured
      if (hash) {
        const targetId = decodeURIComponent(hash.slice(1));
        const el = document.getElementById(targetId);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    const timer = setTimeout(attachAnchors, 150);
    return () => clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}
